import { render, staticRenderFns } from "./studyDataTable.vue?vue&type=template&id=31f4a5a5&scoped=true"
import script from "./studyDataTable.vue?vue&type=script&lang=js"
export * from "./studyDataTable.vue?vue&type=script&lang=js"
import style0 from "./studyDataTable.vue?vue&type=style&index=0&id=31f4a5a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4a5a5",
  null
  
)

export default component.exports